import {useTranslate} from "./locales/use-locales";
import MyChooseLanguage from "./component/base/MyChooseLanguage";

export default function ({children}) {
    const {currentLang} = useTranslate()
    if (!currentLang) return <MyChooseLanguage/>
    return children
}